<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<nz-alert *ngIf="!this.recordHistoryMyExperience && loadInfo" nzType="info"
  class="tw-w-full"
  nzMessage="Para visualizar la ficha es necesario tener una cita en el servicio activo." nzShowIcon></nz-alert>

<form [formGroup]="form" *ngIf="this.recordHistoryMyExperience && loadInfo" @fadeInAnimation>

  <p class="text-info tw-mb-5" *ngIf="userLogged?.patients">Por favor califica cada una de las siguientes afirmaciones sobre tu menú actual. Tu sinceridad es importante para realizar estrategias que impacten positivamente en tus objetivos.</p>

  <nz-alert *ngIf="!this.recordHistoryMyExperience.appointmentId" nzType="info"
  class="tw-w-full tw-mb-4"
  nzMessage="No te encuentras en una cita, no podrás actualizar la ficha." nzShowIcon></nz-alert>

  <nz-alert *ngIf="this.userLogged?.experts && this.recordHistoryMyExperience.appointmentId" nzType="info"
  class="tw-w-full tw-mb-4"
  nzMessage="Nos importa la seguridad y la opinión de los pacientes. Los datos de la ficha solo pueden ser alterados por el paciente, la ficha se mostrará solo en modo lectura." nzShowIcon></nz-alert>

<div nz-row [nzGutter]="[30, 20]">
  <div nz-col nzXs="24" nzLg="7">
    <p class="text-info">Del 1 al 10 que valor de satisfacción le darías al menú</p>
  </div>
  <div nz-col nzXs="24" nzLg="17">
    <div class="tw-flex tw-items-center tw-h-3/6">
      <img src="./../../../assets/images/icons/icons8-dislike-67.png" class="tw-w-5 tw-mr-2" alt="">
      <nz-slider [nzDisabled]="this.form.disabled" formControlName="likedPlan" class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px"  [nzMarks]="marks" [nzMin]="1" [nzMax]="10" [nzStep]="1"></nz-slider>
      <img src="./../../../assets/images/icons/icons8-like-64.png" class="tw-w-5 tw-mr-2" alt="">
    </div>
  </div>
</div>

<nz-divider></nz-divider>

<div nz-row [nzGutter]="[30, 20]">
  <div nz-col nzXs="24" nzLg="7">
    <p class="text-info">Del 1 al 10 ¿Cómo calificas tu apego sincero al plan en todo el período?</p>
  </div>
  <div nz-col nzXs="24" nzLg="17">
    <div class="tw-flex tw-items-center tw-h-3/6">
      <img src="./../../../assets/images/icons/icons8-dislike-67.png" class="tw-w-5 tw-mr-2" alt="">
      <nz-slider [nzDisabled]="this.form.disabled" formControlName="planRatingInPeriod" class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px"  [nzMarks]="marksAdherenceToPlan" [nzMin]="1" [nzMax]="10" [nzStep]="1"></nz-slider>
      <img src="./../../../assets/images/icons/icons8-like-64.png" class="tw-w-5 tw-mr-2" alt="">
    </div>
  </div>
</div>

<nz-divider></nz-divider>

<div nz-row [nzGutter]="[30, 20]">
  <div nz-col nzXs="24" nzLg="7">
    <p class="text-info">¿Te fue fácil o difícil llevar el plan?</p>
  </div>
  <div nz-col nzXs="24" nzLg="17">
    <div class="tw-flex tw-items-center tw-h-3/6">
      <img src="./../../../assets/images/icons/icons8-dislike-67.png" class="tw-w-5 tw-mr-2" alt="">
      <nz-slider [nzDisabled]="this.form.disabled" formControlName="easyOrDifficultFollowThPlan" class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px"  [nzMarks]="marksEasyOrDifficult" [nzMin]="0" [nzMax]="10" [nzStep]="null"></nz-slider>
      <img src="./../../../assets/images/icons/icons8-like-64.png" class="tw-w-5 tw-mr-2" alt="">
    </div>
  </div>
</div>

<nz-divider></nz-divider>

<div nz-row [nzGutter]="[30, 20]">
  <div nz-col nzXs="24" nzLg="7">
    <p class="text-info">Del 1 al 10 ¿Tienes alguna sensación de mejora en tu bienestar general?</p>
  </div>
  <div nz-col nzXs="24" nzLg="17">
    <div class="tw-flex tw-items-center tw-h-3/6">
      <img src="./../../../assets/images/icons/icons8-dislike-67.png" class="tw-w-5 tw-mr-2" alt="">
      <nz-slider [nzDisabled]="this.form.disabled" formControlName="feelingOfImprovementInWellBeing" class="tw-w-full tw-mx-2 tw-relative" style="bottom: -9px"  [nzMarks]="marksWellness" [nzMin]="1" [nzMax]="10" [nzStep]="1"></nz-slider>
      <img src="./../../../assets/images/icons/icons8-like-64.png" class="tw-w-5 tw-mr-2" alt="">
    </div>
  </div>
</div>

<nz-divider></nz-divider>

<div nz-row [nzGutter]="[30, 20]">
  <div nz-col nzXs="24">
    <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100 tw-mb-7">
      <label nz-checkbox formControlName="workOnSomeOtherAspect" class="tw-flex tw-items-center" (ngModelChange)="onChangeWorkOtherAspect($event)">
        <div class="tw-flex tw-items-center">
          <img src="./../../../assets/images/icons/icons8-handshake-100.png" class="tw-w-8 tw-mr-2" alt="">
          <p class="text-info">¿Trabajaste en algún otro aspecto de tu esfera?</p>
        </div>
      </label>
    </div>
  </div>
  <ng-container *ngIf="form.get('workOnSomeOtherAspect').value">
    <div nz-col nzXs="24" @fadeInAnimation class="tw-w-full">
      <p class="text-info tw-mb-2">Por favor ingresa cuál o cuáles.</p>
      <textarea
        nz-input
        placeholder="Ingresa cuál o cuáles"
        [nzAutosize]="{ minRows: 2, maxRows: 6 }" formControlName="workedAspect"></textarea>
      <app-message-field [field]="this.form.get('workedAspect')"></app-message-field>
    </div>
    <div nz-col nzXs="24" @fadeInAnimation class="tw-w-full">
      <p class="text-info tw-mb-2">¿Qué acciones has llevado a cabo?</p>
      <textarea
        nz-input
        placeholder="Acciones"
        [nzAutosize]="{ minRows: 2, maxRows: 6 }" formControlName="actionOfTheWorkedAspect"></textarea>
      <app-message-field [field]="this.form.get('actionOfTheWorkedAspect')"></app-message-field>
    </div>
  </ng-container>
</div>

<div class="d-flex justify-content-end" *ngIf="userLogged?.patients">
  <button [disabled]="this.form.disabled" class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
</div>
</form>
